import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import theme from 'styled-theming';
import { rem } from 'polished';

const baseStyles = css`
  margin: 0;
  font-weight: normal;
  color: ${theme('mode', { light: '#253039', dark: '#fff' })};
`;

const H1 = styled.h1`
  ${baseStyles}
  font-size: ${rem('40px')};

  @media ( max-width: 768px ) {
    font-size: ${rem('34px')};
  }
`;

const H2 = styled.h2`
  ${baseStyles}
  font-size: ${rem('34px')};

  @media ( max-width: 768px ) {
    font-size: ${rem('28px')};
  }
`;

const H3 = styled.h3`
  ${baseStyles}
  font-size: ${rem('26px')};

  @media ( max-width: 768px ) {
    font-size: ${rem('20px')};
  }
`;

class Heading extends React.Component {
  static propTypes = {
    level: PropTypes.number.isRequired,
    children: PropTypes.node,
  }

  render() {
    let component;
    switch (this.props.level) {
      case 1:
        component = <H1 {...this.props}>{this.props.children}</H1>; break;
      case 2:
        component = <H2 {...this.props}>{this.props.children}</H2>; break;
      case 3:
        component = <H3 {...this.props}>{this.props.children}</H3>; break;
      default: component = null;
    }
    return (
      component
    );
  }
}

export default Heading;
